import { supabase } from './supabase';

// Function to check if user is an admin for Water Unity
export const isUserAdmin = async (): Promise<boolean> => {
  try {
    // Check if user is CEO (hamza@avnearth.com) or Eliza (watershedwisdomcouncils@gmail.com)
    const { data: { user } } = await supabase.auth.getUser();
    if (user?.email === 'hamza@avnearth.com' || user?.email === 'watershedwisdomcouncils@gmail.com') {
      return true;
    }
    
    // Check if user is a Water Unity admin
    const { data, error } = await supabase
      .from('water_unity_members')
      .select('is_admin')
      .eq('user_id', user?.id)
      .maybeSingle();
    
    if (error) {
      console.error('Admin check error:', error);
      return false;
    }
    
    return data?.is_admin || false;
  } catch (error) {
    console.error('Admin check error:', error);
    return false;
  }
};

// Function to get user's Water Unity profile
export const getUserProfile = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return { success: false, error: 'Not authenticated' };
    
    const { data, error } = await supabase
      .from('water_unity_members')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();
    
    if (error) {
      throw error;
    }
    
    // If no data was found, return success: false but not as an error
    if (data === null) {
      return { success: false, error: 'No profile found' };
    }
    
    return { success: true, profile: data };
  } catch (error: any) {
    console.error('Get profile error:', error);
    return { success: false, error: error.message };
  }
};

// Function to create or update user's Water Unity profile
export const updateUserProfile = async (profileData: any) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return { success: false, error: 'Not authenticated' };
    
    // Check if profile exists
    const { data: existingProfile } = await supabase
      .from('water_unity_members')
      .select('id')
      .eq('user_id', user.id)
      .single();
    
    let result;
    
    if (existingProfile) {
      // Update existing profile
      const { data, error } = await supabase
        .from('water_unity_members')
        .update({
          ...profileData,
          user_id: user.id
        })
        .eq('id', existingProfile.id)
        .select()
        .single();
      
      if (error) throw error;
      result = data;
    } else {
      // Create new profile
      const { data, error } = await supabase
        .from('water_unity_members')
        .insert({
          ...profileData,
          user_id: user.id
        })
        .select()
        .single();
      
      if (error) throw error;
      result = data;
    }
    
    return { success: true, profile: result };
  } catch (error: any) {
    console.error('Update profile error:', error);
    return { success: false, error: error.message };
  }
};